import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { api } from "../../api/api";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { IStoreState } from "../initialStoreState";
import {
	saveLoaderCompleted,
	saveLoaderProgress,
	showMessage,
} from "../messages/messagesActions";
import { IFeeRecord, IFeeTransition, IStudent } from "./student.types";

//******************************STUDENT FETCHING START *********************************** */

export const FETCH_CUSTOMER_FULL_DETAILS_PROGRESS =
	"FETCH_CUSTOMER_FULL_DETAILS_PROGRESS";
export const ADD_CUSTOMER_FULL_DETAILS_SUCCESS =
	"ADD_CUSTOMER_FULL_DETAILS_SUCCESS";
export const FETCH_CUSTOMER_FULL_DETAILS_FAILED =
	"FETCH_CUSTOMER_FULL_DETAILS_FAILED";

export const fetchStudentListProgress = () =>
	action(FETCH_CUSTOMER_FULL_DETAILS_PROGRESS);
export const fetchStudentListSuccess = (
	data: IStudent[],
	totalRecords: number
) =>
	action(ADD_CUSTOMER_FULL_DETAILS_SUCCESS, {
		data,
		totalRecords,
	});
export const fetchStudentListFailed = () =>
	action(FETCH_CUSTOMER_FULL_DETAILS_FAILED);

export const fetchStudentsListAsync =
	(
		pageNumber: number,
		rowsInPerPage: number,
		status: string,
		date: IDataTableV2DateState["dates"],
		searchValue: IDatatableV2AdvancedSearchFilter,
		organizations_uuid: string,
		courses_uuid: string,
		batch: string,
		academic_year: number
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(fetchStudentListProgress());
			dispatch(saveLoaderProgress());

			let url = "";

			// if(status !== "-1") {
			//   url += `&status=${status}`;}

			if (searchValue.length > 0) {
				url += `&advanceFilter=${JSON.stringify(searchValue)}`;
			}
			if (status !== "-1") {
				url += `&status=${status}`;
			}
			if (organizations_uuid !== "") {
				url += `&organizations_uuid=${organizations_uuid}`;
			}
			if (courses_uuid !== "") {
				url += `&courses_uuid=${courses_uuid}`;
			}
			if (batch !== "") {
				url += `&batch=${batch}`;
			}
			if (academic_year !== undefined) {
				url += `&academic_year=${academic_year}`;
			}
			const finalUrl =
				`/student/get-student?from_date=${date.fromDate}&to_date=${date.toDate}&pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}` +
				url;

			// Make the API call
			const response = await api.get(finalUrl);
			// Check if the response is valid
			if (response.status === 200 && response.data) {
				const data: IStudent[] = response.data.data;

				const totalRecords = response.data.totalRecords;

				console.log(data, "data////////////");

				dispatch(fetchStudentListSuccess(data, totalRecords));
			}
		} catch (err: any) {
			dispatch(fetchStudentListFailed());
			dispatch(
				showMessage({
					type: "error",
					message: err.response?.data?.message,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};

//******************************STUDENT FETCHING END *********************************** */

//***********STUDENT SINGLE DATA FETCH START ******************************************* */
export const FETCH_STUDENT_PROGRESS = "FETCH_STUDENT_PROGRESS";
export const FETCH_STUDENT_SUCCESS = "FETCH_STUDENT_SUCCESS";
export const FETCH_STUDENT_FAILED = "FETCH_STUDENT_FAILED";

export const fetchStudentProgress = () => action(FETCH_STUDENT_PROGRESS);
export const fetchStudentSuccess = (Student: IStudent) =>
	action(FETCH_STUDENT_SUCCESS, { Student });
export const fetchStudentFailed = (errorMessage: string) =>
	action(FETCH_STUDENT_FAILED, { errorMessage });

export const fetchStudentAsync =
	(studentUUID: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(fetchStudentProgress());
			dispatch(saveLoaderProgress());
			const res = await api.get(
				`/student/get-student?customer_fact_uuid=${studentUUID}`
			);
			const data = res.data.data;
			if (data.length > 0) {
				dispatch(fetchStudentSuccess(data[0]));
			} else {
				dispatch(
					fetchStudentFailed(
						"Unfortunately, there are no records available at the moment."
					)
				);
			}
		} catch (err: any) {
			dispatch(fetchStudentFailed("Something went to be wrong!"));
			dispatch(
				showMessage({
					type: "error",
					message: err.response?.data?.message,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};

//******************************STUDENT SINGLE DATA FETCH END *********************************** */

//******************************STUDENT UPSERT START *********************************** */
export const upsertStudentAysnc =
	(
		existingLead: IStudent,
		onCallBack: (isSuccess?: boolean, data?: IStudent) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		dispatch(saveLoaderProgress());
		try {
			const {
				customer_personal_information_unique_id,
				customer_personal_information_id,
				created_by_uuid,
				created_by_name,
				create_ts,
				insert_ts,
				modified_by_name,
				modified_by_uuid,
				opportunity_uuid,
				session_uuid,
				...rest
			} = existingLead;
			console.log(rest);

			const res = await api.post("/student/update-student", rest);
			dispatch(
				showMessage({
					type: "success",
					message: "Student is saved succesfully!",
					displayAs: "snackbar",
				})
			);
			const data = res.data.data;
			onCallBack(true, data);
		} catch (err: any) {
			onCallBack(false);
			dispatch(
				showMessage({
					type: "error",
					message: err.response?.data?.message,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};

//********************************STUDENT UPSERT END *********************************** */

//********************************FEE TRANSITION START *********************************** */

export const FETCH_FEE_TRANINSTION_LIST_PROGRESS =
	"FETCH_FEE_TRANINSTION_LIST_PROGRESS";
export const FETCH_FEE_TRANINSTION_LIST_SUCCESS =
	"ADD_FEE_TRANINSTION_LIST_SUCCESS";
export const FETCH_FEE_TRANINSTION_LIST_FAILED =
	"FETCH_FEE_TRANINSTION_LIST_FAILED";

export const fetchFeeTransitionListProgress = () =>
	action(FETCH_FEE_TRANINSTION_LIST_PROGRESS);
export const fetchFeeTransitionListSuccess = (
	data: IFeeTransition[],
	totalRecords: number
) =>
	action(FETCH_FEE_TRANINSTION_LIST_SUCCESS, {
		data,
		totalRecords,
	});
export const fetchFeeTransitionListFailed = () =>
	action(FETCH_FEE_TRANINSTION_LIST_FAILED);

export const fetchhFeeTransitionListAsync =
	(
		pageNumber: number,
		rowsInPerPage: number,

		studentFactId: string | null,
		date?: IDataTableV2DateState["dates"],
		status?: string,
		searchValue?: IDatatableV2AdvancedSearchFilter
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(fetchFeeTransitionListProgress());
			// dispatch(saveLoaderProgress());

			let url = "";

			// if(status !== "-1") {
			//   url += `&status=${status}`;}

			// if(searchValue.length > 0) {
			//   url += `}&advanceFilter=${JSON.stringify(searchValue)}`
			// }

			if (studentFactId !== null) {
				url += `&customer_fact_uuid=${studentFactId}`;
			}

			const finalUrl =
				`/student/get-fee-transaction?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}` +
				url;
			// &from_date=${date.fromDate}&to_date=${date.toDate}

			// Make the API call
			const response = await api.get(finalUrl);
			// Check if the response is valid
			if (response.status === 200 && response.data) {
				const data: IFeeTransition[] = response.data.data;

				const totalRecords = response.data.totalRecords;

				console.log(data, "data////////////");

				dispatch(fetchFeeTransitionListSuccess(data, totalRecords));
			}
		} catch (err: any) {
			dispatch(fetchFeeTransitionListFailed());
			dispatch(
				showMessage({
					type: "error",
					message: err.response?.data?.message,
					displayAs: "snackbar",
				})
			);
		}
		// finally{
		//   dispatch(saveLoaderCompleted());
		// }
	};

//******************************* FEE RECORDS START *********************************** */

export const FETCH_FEE_RECORD_LIST_PROGRESS = "FETCH_FEE_RECORD_LIST_PROGRESS";
export const FETCH_FEE_RECORD_LIST_SUCCESS = "FETCH_FEE_RECORD_LIST_SUCCESS";
export const FETCH_FEE_RECORD_LIST_FAILED = "FETCH_FEE_RECORD_LIST_FAILED";

export const fetchFeeRecordListProgress = () =>
	action(FETCH_FEE_RECORD_LIST_PROGRESS);
export const fetchFeeRecordListSuccess = (data: IFeeRecord) =>
	action(FETCH_FEE_RECORD_LIST_SUCCESS, {
		data,
	});
export const fetchFeeRecordListFailed = (errorMessage: string) =>
	action(FETCH_FEE_RECORD_LIST_FAILED, {
		errorMessage,
	});

interface IRecord {
	student_Fact_id: string;
	batch: string;
	course_uuid: string;
	academic_year: number;
}

export const fetchhFeeRecordAsync =
	(data: IRecord): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(fetchFeeRecordListProgress());

			const finalUrl = `/student/get-student-fee-record?customer_fact_uuid=${data.student_Fact_id}&batch=${data.batch}&courses_uuid=${data.course_uuid}&academic_year=${data.academic_year}`;

			const response = await api.get(finalUrl);
			if (response.status === 200 && response.data) {
				const data: IFeeRecord = response.data.data;

				console.log(data, "data////////////");

				dispatch(fetchFeeRecordListSuccess(data));
			}
		} catch (err: any) {
			dispatch(fetchFeeRecordListFailed(err.response?.data?.message));
			dispatch(
				showMessage({
					type: "error",
					message: err.response?.data?.message,
					displayAs: "snackbar",
				})
			);
		}
		// finally{
		//   dispatch(saveLoaderCompleted());
		// }
	};

export const upsertFeeTransitionAsync =
	(
		existingLead: IFeeTransition,
		onCallBack: (isSuccess?: boolean, data?: IFeeTransition) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			// De-structure everything except these fields
			const {
				fee_transaction_id,
				fee_transaction_unique_id,
				opportunity_uuid,
				created_by_uuid,
				created_by_name,
				modified_by_uuid,
				modified_by_name,
				create_ts,
				insert_ts,
				academic_year,
				batch,
				courses_name,
				organizations_name,
				organizations_uuid,
				customer_code,
				...payload
			} = existingLead;
			dispatch(saveLoaderProgress());

			const res = await api.post("/student/insert-fee-transaction", payload);

			dispatch(
				showMessage({
					type: "success",
					message: "Fee Transition is saved succesfully!",
					displayAs: "snackbar",
				})
			);
			const data = res.data.data;
			onCallBack(true, data);
		} catch (err: any) {
			dispatch(saveLoaderCompleted());
		}
	};

//******************************* FEE RECORDS END *********************************** */

//********************************FEE TRANSITION END *********************************** */

export const CLEAR_STUDENT_STATE = "CLEAR_STUDENT_STATE";
export const CLEAR_STUDENT = "CLEAR_STUDENT";

export const clearStudentsState = () => action(CLEAR_STUDENT_STATE);
export const clearStudent = () => action(CLEAR_STUDENT);
